import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./assignedWork.css";

const AssignedWork = () => {
  const [orders, setOrders] = useState([]);
  const employeeId = localStorage.getItem("employee_id");
  const navigate = useNavigate();

  // ✅ Fetch assigned work
  useEffect(() => {
    if (!employeeId) return;
    fetch(
      `https://www.actrofiteinfotech.com/rootservices/dashboard/assigned_work.php?employee_id=${employeeId}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") setOrders(data.data);
      })
      .catch((err) => console.error(err));
  }, [employeeId]);

  // ✅ Auto-update agent live location every 15 seconds
  useEffect(() => {
    if (!employeeId) return;

    const updateLocation = () => {
      if (!navigator.geolocation) {
        console.warn("Geolocation is not supported by this browser.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          fetch("https://www.actrofiteinfotech.com/rootservices/backend/update_agent_location.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            mode: "cors",
            body: JSON.stringify({ employee_id: employeeId, lat, lng }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.status === "success") {
                console.log("✅ Location updated:", lat, lng);
              } else {
                console.error("❌ Update failed:", data);
              }
            })
            .catch((err) => console.error("Fetch error:", err));
        },
        (error) => {
          console.error("Geolocation error:", error);
          if (error.code === 1) {
            alert("Please allow location access for live tracking.");
          }
        }
      );
    };

    // First update immediately
    updateLocation();

    // Update every 15 seconds
    const interval = setInterval(updateLocation, 15000);

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, [employeeId]);

  return (
    <div className="assigned-work-container">
      <h2>My Assigned Work</h2>
      {orders.length === 0 ? (
        <p className="no-work">No assigned work found.</p>
      ) : (
        orders.map((order) => {
          const isCompleted =
            order.order_status &&
            order.order_status.toLowerCase() === "work completed";

          return (
            <div
              key={order.id}
              className="assigned-card"
              onClick={() => navigate(`/assigned-work/${order.id}`)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="card-header"
                style={{
                  background: isCompleted
                    ? "linear-gradient(135deg, #28a745, #218838)"
                    : "linear-gradient(135deg, #4a90e2, #357abd)",
                }}
              >
                {order.main_service} → {order.sub_service_title}{" "}
                {isCompleted && "(Completed)"}
              </div>
              <div className="card-body">
                <p>
                  <strong>Order ID:</strong> {order.id}
                </p>
                <p>
                  <strong>Customer Name:</strong> {order.name}
                </p>
                <p>
                  <strong>Address:</strong> {order.address || "No address"}
                </p>
                <p>
                  <strong>Status:</strong> {order.order_status || "No status"}
                </p>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default AssignedWork;
